module.exports = __webpack_public_path__ + "img/sad-cat.2220c670.svg";